import React from "react";
import {NavLink} from "react-router-dom";

// Models
import ICarouselContentDTO from "../../../../../Models/DTOs/ICarouselContentDTO";
import VideoDTO from "../../../../../Models/DTOs/VideoDTO";

// Helpers
import {GetContentRedirect} from "../../../../../Helpers/Content/Content";

type EnrichedCarouselItem = ICarouselContentDTO & {
    LatestVideo?: VideoDTO | null;
    LatestVideoEpoch?: number;
};

type Props = {
    item: EnrichedCarouselItem;
    isLoading: boolean;
};

const PortraitPresenterItem: React.FC<Props> = ({ item, isLoading }) => {
    const earlyAccessAvailable =
        item.ReleaseDateEarlyAccess !== undefined &&
        new Date(`${item.ReleaseDateEarlyAccess}Z`) < new Date() &&
        item.Text === "Film";

    const redirect =
        item.IsClickeable || earlyAccessAvailable
            ? GetContentRedirect(item.ContentType, item.Id)
            : null;

    const dt = item.LatestVideo?.Datetime ? new Date(item.LatestVideo.Datetime) : null;

    return (
        <NavLink to={redirect ? redirect : "#"} className="u-relative_hidden">
            {isLoading ? (
                <div className="loader--side-to-side" />
            ) : (
                <>
                    <div
                        className="u-full_cover_absolute"
                        style={{
                            background: `url("${item.PortraitThumbnail ?? ""}") center/cover no-repeat`,
                        }}
                    />
                    {dt && (
                        <label><span>
                            {(() => {
                                const day = String(dt.getDate()).padStart(2, "0");
                                const month = String(dt.getMonth() + 1).padStart(2, "0");
                                return `Latest Episode: ${day}/${month}`;
                            })()}
                        </span></label>
                    )}
                </>
            )}
        </NavLink>
    );
};

export default PortraitPresenterItem;
